import { render, staticRenderFns } from "./ApplicantType.vue?vue&type=template&id=2573a661&scoped=true&"
import script from "./ApplicantType.vue?vue&type=script&lang=js&"
export * from "./ApplicantType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2573a661",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VFadeTransition,VSlideYTransition})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2573a661')) {
      api.createRecord('2573a661', component.options)
    } else {
      api.reload('2573a661', component.options)
    }
    module.hot.accept("./ApplicantType.vue?vue&type=template&id=2573a661&scoped=true&", function () {
      api.rerender('2573a661', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application/components/Application/Setup/ApplicantType.vue"
export default component.exports